module.exports = __webpack_public_path__ + "static/media/user_icon.0135364d.svg";